import { render, staticRenderFns } from "./SwitchCompany.vue?vue&type=template&id=049d444b"
import script from "./SwitchCompany.vue?vue&type=script&lang=js"
export * from "./SwitchCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports